import React, { Component } from 'react';
import Filter from '@/components/SendingRecord/Filter'
import styled from "styled-components"
import OperationAPI from '@/API/operation'
import { Table, Spin } from 'antd'
import dayjs from 'dayjs'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Container = styled.div`
  padding: 20px;
`;

const RecordTable=styled(Table)`
  margin-top:20px;
`

const Contain=styled.div`
  margin-top:10px;
`

const Tips = styled.div`
  line-height:42px;
  color:#999999;
  background-color:#f4f5f9;
  width: 100%;
  position:absolute;
  top:0;
  left:0;
  padding:0 20px;
  overflow-x: hidden;
  white-space: nowrap;
`;

class ActionRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      filter:{
        operator:'',
        notifyType:-1,
        time:[]
      },
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      operationList:[]
    };
  }
  componentDidMount() {
    if(this.props.roleId){
      if(this.props.roleId===3){
        this.setState((prevState)=>({
          filter:{
            ...prevState.filter,
            operator:this.props.operator
          }
        }),()=>{
          if(this.props.operator){
            this.search()
          }
        })
      }else{
        this.search()
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.operator&&this.props.operator!==prevProps.operator) {
      if(this.props.roleId===3){
        this.setState((prevState)=>({
          filter:{
            ...prevState.filter,
            operator:this.props.operator
          }
        }),()=>{
          if(this.props.operator){
            this.search()
          }
        })
      }else{
        this.search()
      }
    }
  }
  search=()=>{
    this.setState((prevState)=>({
      pagination:{
        ...prevState.pagination,
        current:1
      }
    }),()=>{
      this.getData()
    })
  }
  getData=()=>{
    this.setState({loading:true})
    const {filter,pagination}=this.state
    const startTime=filter.time[0]?dayjs(filter.time[0]).startOf('day').unix():null
    const endTime=filter.time[1]?dayjs(filter.time[1]).endOf('day').unix():null
    OperationAPI.getRecords({
      operator:filter.operator,
      notifyType:filter.notifyType,
      startTime:startTime,
      endTime:endTime,
      pageIndex:pagination.current-1,
      pageSize:pagination.pageSize
    }).then((res)=>{
      console.log(res)
      this.setState((prevState)=>({
        loading:false,
        operationList:res.logs,
        pagination:{
          ...prevState.pagination,
          total:res.totalCount
        }
      }))
    }).catch(()=>{
      this.setState({loading:false})
    })
  }
  filterChange=(key,value)=>{
    let field={}
    field[key]=value
    this.setState(prevState=>({
      filter:{
        ...prevState.filter,
        ...field
      }
    }))
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getData()
    });
  }
  render() {
    const {loading,operationList,pagination}=this.state
    const { t } = this.props;
    const columns=[
      {
        title:t('Type'),
        dataIndex:'notifyType',
        key:'notifyType',
        width:150,
        align:'center'
      },
      {
        title:t('Time'),
        key:'operateTime',
        width:180,
        align:'center',
        render:(text,record)=>{
          return record.operateTime?dayjs(record.operateTime).format('YYYY-MM-DD HH:mm:ss'):''
        }
      },
      {
        title:t('Sent'),
        dataIndex:'totalCount',
        key:'totalCount',
        width:150,
        align:'center'
      },
      {
        title:t('Successful'),
        dataIndex:'successCount',
        key:'successCount',
        width:150,
        align:'center'
      },
      {
        title:t('Failed'),
        dataIndex:'failCount',
        key:'failCount',
        width:150,
        align:'center'
      },
      {
        title:t('Carrier Code'),
        dataIndex:'operator',
        key:'operator',
        width:180,
        align:'center'
      },
      {
        title:t('Operator'),
        dataIndex:'userName',
        key:'userName',
        width:150,
        align:'center'
      }
    ]    
    return (
      <Container>
        {/* <Tips>{t('Note: The instruction sending records will be sent to your email address in table format. You can check them in your associated mailbox.')}</Tips> */}
        <Contain>
          <Filter filterChange={this.filterChange} search={this.search}></Filter>
          <Spin spinning={loading}>
            <RecordTable columns={columns} dataSource={operationList} rowKey="id" pagination={pagination} onChange={this.handleTableChange}></RecordTable>
          </Spin>
        </Contain>
      </Container>
    );
  }
}

const mapStateToProps = (state)=>{
  return {
    operator:state.operator,
    roleId:state.roleId
  }
}

export default connect(mapStateToProps)(withTranslation()(ActionRecord));